import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  formContainer: {
    marginTop: theme.spacing(3),
    '& .MuiInputBase-input:-webkit-autofill': {
      boxShadow: `inset 0 0 0 1000px transparent`,
    },
    '& .MuiInputBase-input:autofill': {
      boxShadow: `inset 0 0 0 1000px transparent`,
    },
    '& input:-internal-autofill-selected': {
      backgroundColor: 'transparent !important',
    },
  },
  textField: {
    marginBottom: theme.spacing(2),
    '& textarea': {
      padding: theme.spacing(1.5, 0),
    },
    '& label': {
      color: '#818181',
      marginTop: theme.spacing(1),
      '&.MuiInputLabel-shrink': {
        color: theme.palette.text.secondary,
      },
    },
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(4),
    },
  },
  sectionText: {
    margin: 0,
    '& a': {
      color: theme.palette.text.primary,
      textDecoration: 'none',
    },
  },
  goToFaqsHeadingSection: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(10),
  },
  faqLinkSection: {
    marginTop: theme.spacing(2),
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '[lang=ar] &': {
      '& svg': {
        marginTop: '11px',
      },
    },
  },
  faqLink: {
    fontSize: '1.375rem',
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
  },
  [theme.breakpoints.down('xs')]: {
    bannerContainer: {
      padding: theme.spacing(0),
    },
    contactSidebar: {
      paddingRight: theme.spacing(0),
    },
    contactFormSection: {
      marginTop: theme.spacing(5),
      padding: theme.spacing(0),
    },
    notACustomerHeading: {
      margin: theme.spacing(0, 0, 3),
    },
    writeUsHeading: {
      margin: theme.spacing(3, 0),
    },
    supportPageForm: {
      marginTop: theme.spacing(4.5),
    },
  },
  [theme.breakpoints.up('sm')]: {
    bannerText: {
      padding: theme.spacing(0, 11),
    },
    mainFormContainer: {
      padding: theme.spacing(0, 16),
    },
    contactSidebar: {
      paddingRight: theme.spacing(0),
    },
    contactFormSection: {
      marginTop: theme.spacing(5),
      padding: theme.spacing(0),
    },
    notACustomerHeading: {
      margin: theme.spacing(0, 0, 3),
    },
    writeUsHeading: {
      margin: theme.spacing(0, 0, 6),
    },
  },
  [theme.breakpoints.up('md')]: {
    bannerText: {
      padding: theme.spacing(0, 12),
    },
    contactSidebar: {
      paddingRight: theme.spacing(5),
    },
    contactFormSection: {
      marginTop: theme.spacing(0),
      padding: theme.spacing(0),
    },
    mainFormContainer: {
      padding: theme.spacing(0, 12, 0, 17),
    },
    writeUsHeading: {
      width: '520px',
    },
    sectionText: {
      width: '303px',
    },
  },
  submitButton: {
    borderRadius: 2,
    fontSize: '1.125rem',
    fontWeight: 500,
    '& button': {
      padding: theme.spacing(0.75, 3),
      fontSize: '1rem',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1, 1.5),
      },
    },
    overflow: 'hidden',
    '& svg': {
      color: 'inherit',
    },
  },
  [theme.breakpoints.up('lg')]: {
    mainFormContainer: {
      padding: theme.spacing(0, 12),
    },
    contactFormSection: {
      marginTop: theme.spacing(0),
      padding: theme.spacing(0, 5),
    },
  },
}))
